<template>
   <div>        
       <div id="mc_embed_signup">
<form action="https://halfhumangames.us20.list-manage.com/subscribe/post?u=0137a8236f6ae6db0a6cc9b2b&amp;id=e0b4502ce9" method="post" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form" class="validate" target="_blank" novalidate>
    <div id="mc_embed_signup_scroll">
	
<div class="mc-field-group">

	<input type="email" value="" placeholder="Email" name="EMAIL" class="required email" id="mce-EMAIL">
</div>
	<div id="mce-responses" class="clear">
		<div class="response" id="mce-error-response" style="display:none"></div>
		<div class="response" id="mce-success-response" style="display:none"></div>
	</div>    <!-- real people should not fill this in and expect good things - do not remove this or risk form bot signups-->
    <div style="position: absolute; left: -5000px;" aria-hidden="true"><input type="text" name="b_0137a8236f6ae6db0a6cc9b2b_e0b4502ce9" tabindex="-1" value=""></div>
    <div class="clear"><input type="image" v-model="email" value="Subscribe" name="subscribe" id="mc-embedded-subscribe" class="button animated pulse animated-infinite bounce_button" src="/static/assets/images/Subscribe.png"></div>
     <p class="subtitle">You will be entered for a chance to win <span> alpha access!</span></p>
    </div>
</form>
</div>        
    </div>      
</template>

<script>
import axios from 'axios';

export default {
    data: function() {
    return {
        email: '',
        response: {}
    };
  },
  methods: {
    mailtrainStyling() {
      var mailForm = document.getElementsByClassName(
        "mailtrain-subscription-widget"
      );
      var h3 = mailForm[0];
      h3.innerHTML = h3.innerHTML.replace(
        "Newsletter",
        "Sign up for our newsletter!"
      );
      h3.className += " cta-title";
    },
    onSubmit() {
       $.ajax({
        url: 'http://halfhumangames.us20.list-manage.com/subscribe/post?u=0137a8236f6ae6db0a6cc9b2b&amp;id=e0b4502ce9',
        type: 'POST',
        data: $('#mc-embedded-subscribe-form').serialize(),
        dataType: 'jsonp',
        contentType: "application/json; charset=utf-8",
        success: function (data) {
           if (data['result'] != "success") {
                //ERROR
                console.log(data['msg']);
           } else {
                console.log(data['msg']);
                //SUCCESS - Do what you like here
           }
        }
    });
      
    }
  },
  mounted() {
     delete window.mailtrain; 
    let mailtrain = document.createElement('script')
    console.log('mailtrain')
    // This tells it to run as soon as it gets loaded
    mailtrain.async = true 
    mailtrain.setAttribute('src', '//s3.amazonaws.com/downloads.mailchimp.com/js/mc-validate.js')
    document.head.appendChild(mailtrain)
    
  }
};

</script>

<style>

.module-small div#mc_embed_signup {
    top: 0;
}
.module-small input#mce-EMAIL {
    background: #fff;
}
.module-small #mc_embed_signup .mc-field-group {
    padding-top: 12px;
}
#mc_embed_signup {
    clear: left;
    font: 14px Helvetica,Arial,sans-serif;
    max-width: 538px;
    margin: auto;
    border-radius: 6px;
    position: relative;
    top: 22px;
    /* top: 74px; */

}
input#mce-EMAIL {
    color: #bfb6b6;
    height: 44px;
    display: block !IMPORTANT;
    width: 79% !important;
    padding: 10px 0 !important;
    background-color: rgba(0, 0, 0, 0.38);
    border: 2px solid rgba(255, 255, 255, 0.39);
}
form#mc-embedded-subscribe-form {
    padding: 0;
}
 section#heroheader input[type="email"]::placeholder {
    color: #fff;
}
#mc_embed_signup .mc-field-group {
    margin: auto;
        padding-top: 25px;

}
.mce_inline_error {
    display: none !important;
}
input#mc-embedded-subscribe {
      background: transparent !important;
    width: 127px !important;
    height: auto !important;
    float: right;
    padding: 0 !important;
}


#mc_embed_signup .mc-field-group label {
    font-size: 20px !important;
    text-shadow: 1px 1px #080808;
    padding: 0 0 10px !important;
    margin: 0 0 7px !important;
     text-align: center;
    font-family: Grandmaster;
}
#mc_embed_signup .mc-field-group i.fa.fa-envelope {
    position: absolute;
    color: #3c9bd0 !IMPORTANT;
    font-size: 47px;
    top: -24px;
    text-shadow: none;
    width: 79px;
    border-radius: 63px;
    padding: 15px;
    left: -62px;
    filter: drop-shadow(3px 4px 0px #1b1935);
    background: #ffffff;
}
p.subtitle {
   font-size: 16px !important;
    margin-bottom: 0;
    color: #fff !important;
    font-family: Grandmaster;
    padding-top: 0px;
    padding-left: 23px;
        width: 100%;
    position: absolute;
    line-height: 1.5;
    text-align: center;
    text-shadow: -2.4px -2.4px 0 #282e35, -2.4px -1.4px 0 #282e35, -2.4px -0.4px 0 #282e35, -2.4px 0.6px 0 #282e35, -2.4px 1.6px 0 #1d1a44, -2.4px 2.6px 0 #282e35, -1.4px -2.4px 0 #282e35, -1.4px -1.4px 0 #282e35, -1.4px -0.4px 0 #282e35, -1.4px 0.6px 0 #282e35, -1.4px 1.6px 0 #282e35, -1.4px 2.6px 0 #282e35, -0.4px -2.4px 0 #282e35, -0.4px -1.4px 0 #282e35, -0.4px -0.4px 0 #282e35, -0.4px 0.6px 0 #282e35, -0.4px 1.6px 0 #282e35, -0.4px 2.6px 0 #282e35, 0.6px -2.4px 0 #282e35, 0.6px -1.4px 0 #282e35, 0.6px -0.4px 0 #282e35, 0.6px 0.6px 0 #282e35, 0.6px 1.6px 0 #282e35, 0.6px 2.6px 0 #282e35, 1.6px -2.4px 0 #282e35, 1.6px -1.4px 0 #282e35, 1.6px -0.4px 0 #282e35, 1.6px 0.6px 0 #282e35, 1.6px 1.6px 0 #282e35, 1.6px 2.6px 0 #282e35, 2.6px -2.4px 0 #282e35, 2.6px -1.4px 0 #282e35, 2.6px -0.4px 0 #282e35, 2.6px 0.6px 0 #282e35, 2.6px 1.6px 0 #282e35, 2.6px 2.6px 0 #282e35;
}
#mc_embed_signup .clear:nth-child(4) {
    clear: both;
    position: relative;
    top: -61px;
    /* left: 23px; */
    left: 157PX;
}
#mc_embed_signup div.response {
    font-size: 12px;
    position: absolute;
    font-family: Grandmaster;
    top: 96px;
    width: 100%;
    line-height: 1.5;
    font-weight: 100;
}
p.subtitle span {
       font-size: 18px;
    color: #23affd;
}
.content__monkeyRewards{
    display: none !Important;
}
@media (max-width: 681px){
#mc_embed_signup .mc-field-group {
    position: relative;
    top: -62px;
}
input#mce-EMAIL {
    width: 100% !important;
}
#mc_embed_signup .clear:nth-child(4) {
    left: 0;
    text-align: center;
}
p.subtitle {
    top: 85px;
}
input#mc-embedded-subscribe {
    float: inherit;
    left: 32%;
}
.module-small div#mc_embed_signup {
    top: 59px;
    }
}
</style>


// WEBPACK FOOTER //
// src/views/Home/MailTrain.vue